<div class="mx-auto p-20 text-white" *ngIf="isLoading">
	<h1 class="text-center"><i class="fas fa-spinner fa-spin mr-2"></i> Loading data...</h1>
</div>
